import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import i18n from '../R/string/i18n';
import color from '../utils/style/color';
import { fontWeight, fontSize } from '../utils/style/font';
import Image from '../atoms/Image';
import assets from '../R/assets';
import ConfirmEmailSentModalBackground from '../atoms/ConfirmEmailSentModalBackground';

type Props = {
  title: string;
  body: string;
  subText: string;
  icon: string;
  isOpen: boolean;
  onRequestClose: () => void;
};

const BodyWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const Title = styled.div`
  font-size: 22px;
  font-weight: ${fontWeight.normal};
  line-height: 1.5;
  color: ${color.gray.xxDark};
`;

const MainText = styled.div`
  line-height: 1.5;
  font-size: ${fontSize.l}px;
`;

const SubText = styled.div`
  color: ${color.gray.lightDark};
  line-height: 1.5;
  font-size: ${fontSize.xs}px;
`;

const CloseButton = styled.div`
  display: grid;
  place-items: center;
  width: 100%;
  max-width: 114px;
  height: 52px;
  font-size: ${fontSize.l}px;
  border: 1px solid ${color.red.brand};
  border-radius: 2px;
  color: ${color.red.brand};
  box-sizing: border-box;
  background-color: ${color.gray.xxxxBright};
  transition: all 0.3s ease;

  @media screen and (max-width: 576px) {
    max-width: 100%;
    width: calc(100% - 40px);
  }

  &:hover {
    cursor: pointer;
    color: ${color.red.brand};
    background-color: ${color.pink.xxxxBright};
  }
`;

const CloseButtonIcon = styled.button`
  background: none;
  position: absolute;
  right: -18px;
  top: -18px;
  cursor: pointer;
`;

const onOpen = () => {
  document.body.style.overflow = 'hidden';
};

const onClose = () => {
  document.body.style.overflow = 'visible';
};

const ConfirmEmailSentModal = (props: Props) => {
  const modalStyles = {
    overlay: {
      zIndex: 3,
      backgroundColor: 'rgba(0, 0, 0, 0.3)'
    },
    content: {
      backgroundColor: 'transparent',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      border: 'none',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)'
    }
  };

  return (
    <Modal
      isOpen={props.isOpen}
      style={modalStyles}
      onAfterOpen={onOpen}
      onAfterClose={onClose}
    >
      <ConfirmEmailSentModalBackground>
        <BodyWrapper>
          <CloseButtonIcon onClick={props.onRequestClose}>
            <Image
              src={assets.closeIcon}
              alt={i18n.commonCloseButton()}
              width={18}
              height={18}
            />
          </CloseButtonIcon>
          <Image
            src={assets.passwordResetConfirm}
            alt={props.body}
            width={150}
            height={135}
          />
          <Title>{props.title}</Title>
          <MainText>{props.body}</MainText>
          <SubText>{props.subText}</SubText>
          <CloseButton onClick={props.onRequestClose}>
            {i18n.commonCloseButton()}
          </CloseButton>
        </BodyWrapper>
      </ConfirmEmailSentModalBackground>
    </Modal>
  );
};

export default ConfirmEmailSentModal;
